export default "__VITE_ASSET__2b0b80dd__"